module.exports = __webpack_public_path__ + "static/img/preview-06.3229397d.webp";